<main class="app-container">
  <app-action-bar></app-action-bar>
  <div class="content-wrapper fade-in">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</main>